import axios from 'axios';

export default axios.create({
  baseURL: process.env.REACT_APP_I9_ENDPOINT,
  headers: { 'x-api-key': process.env.REACT_APP_I9_TOKEN },
});
